module.exports = __webpack_public_path__ + "static/hifi1-2549409bb7d362df0a170e7063c8d126.jpg";